import fs from 'fs';
import path from 'path';

import chalk from 'chalk';

import { graftText, wikilinkBulletRe } from 'semtree';

import { MD } from '../util/const';
import { getConfig } from '../util/config';
import { analyzeGraftWarnings, type InitTree } from '../util/tree';
import { getIndexFileUris, resetGlobCache } from '../util/util';


export function graft(child: string, newParent: string, payload: InitTree, argv?: any): void {
  const dryRun: boolean = !!(argv?.dryRun ?? argv?.['dry-run']);
  const cfg: any = getConfig(payload.configUri);
  const indentWidth: number = cfg?.format?.indent_size ?? 2;
  if (child === newParent) {
    console.error(chalk.red('child and parent must differ'));
    return;
  }
  const childPath: string = path.join(process.cwd(), child + MD);
  const parentPath: string = path.join(process.cwd(), newParent + MD);
  if (!fs.existsSync(childPath)) {
    console.error(chalk.red(`no such file: ${child}${MD}`));
    return;
  }
  if (!fs.existsSync(parentPath)) {
    console.error(chalk.red(`no such file: ${newParent}${MD}`));
    return;
  }
  const uris: string[] | undefined = getIndexFileUris(payload.doctypeUri, payload.globIndexUris);
  if (!uris || uris.length === 0) {
    console.error(chalk.red('no index files found'));
    return;
  }
  const cwd: string = process.cwd();
  for (const uri of uris) {
    const content: string = fs.readFileSync(uri, 'utf8');
    const lines: string[] = content.split(/\r?\n/);
    const childLineRe: RegExp = wikilinkBulletRe(child);
    const parentLineRe: RegExp = wikilinkBulletRe(newParent);
    let ci: number = -1;
    let pi: number = -1;
    for (let i: number = 0; i < lines.length; i++) {
      if (childLineRe.test(lines[i])) {
        ci = i;
      }
      if (parentLineRe.test(lines[i])) {
        pi = i;
      }
    }
    if (ci === -1 || pi === -1 || ci === pi) {
      continue;
    }
    const next: string | null = graftText(content, child, newParent, indentWidth);
    if (next === null) {
      continue;
    }
    const indexRelPath: string = path.relative(cwd, uri) || path.basename(uri);
    analyzeGraftWarnings(lines, ci, indexRelPath, indentWidth);
    if (dryRun) {
      console.log(formatDryRun(child, newParent, indexRelPath));
      return;
    }
    if (next !== content) {
      fs.writeFileSync(uri, next, 'utf8');
    }
    resetGlobCache();
    console.log(formatSuccess(child, newParent));
    return;
  }
  console.error(formatError(child, newParent));
}

// format

function formatDryRun(child: string, newParent: string, indexRelPath: string): string {
  return chalk.cyan(`[dry-run] would graft [[${child}]] under [[${newParent}]] in ${indexRelPath} (no changes written)`);
}

function formatSuccess(child: string, newParent: string): string {
  return `grafted [[${child}]] under [[${newParent}]]`;
}

function formatError(child: string, newParent: string): string {
  return chalk.red(`could not graft [[${child}]] under [[${newParent}]] (not found in index or already placed)`);
}